@if (loading()) {
	<lb-loader message="Loading lesson details..."></lb-loader>
} @else if (resourceError(); as error) {
	<lb-resource-error [type]="error" resourceLabel="lesson" [backLink]="lessonsListLink" backLabel="All Lessons"></lb-resource-error>
} @else if (lesson(); as lesson) {
	<div class="lesson-page">
		<!-- Lesson-context chrome: back to the list this page was opened from, and across to the lesson's
		     Enrollment Overview. The enrollment-context host (enrollment-lesson-wrapper) has the shell's
		     tabs and timeline for this instead. -->
		<div class="lesson-page__actions">
			<a md-button [routerLink]="lessonsListLink">
				<md-icon icon="untitled-ui/arrows/arrow-left"></md-icon>
				All Lessons
			</a>
			<span class="lesson-page__spacer"></span>
			@if (enrollmentLink(); as enrollmentLink) {
				<a md-button [routerLink]="enrollmentLink">View Enrollment</a>
			}
		</div>

		@if (state.experience() === 'instructor') {
			<lb-instructor-lesson-detail />
		} @else if (state.experience() === 'learner') {
			<lb-learner-lesson-detail />
		}
	</div>
}
